class exports.Field extends KoModel

    constructor: (data = {}) ->
        super()

        @name       = ko.observable data.name ? ""
        @farm       = ko.observable data.farms_id ? null
        @id         = data.id ? null

        @rawAcres   = ko.observable(0)
        @acreage    = ko.computed () =>
            return @rawAcres().toFixed(1)

        @tile_density           = ko.observable data.tile_density ? null
        @tile_spacing           = ko.observable data.tile_spacing ? null
        @previous_crop          = data.previous_crop ? null
        @soil_productivity      = data.soil_productivity ? null
        @geometry               = data.geometry ? null


    displayGeometry: () ->
        if @geometry? and @geometry instanceof L.FeatureGroup
            App.map.addLayer @geometry


    hideGeometry: () ->
        if @geometry? and @geometry instanceof L.FeatureGroup
            App.map.removeLayer @geometry



    destroy: () ->
        @hideGeometry()
        if @irrigationGeometry? and @irrigationGeometry instanceof L.FeatureGroup
            App.map.removeLayer @irrigationGeometry


    save: (cb) ->
        wkt = new Wkt.Wkt()
        geom = wkt.fromObject(@geometry).write()

        fieldPost = {
            farms_id: @farm()
            id: @id
            geom: geom
            name: @name()
            tile_density: @tile_density()
            tile_spacing: @tile_spacing()
            irrigation_type: @irrigation_type
            previous_crop: @previous_crop
            soil_productivity: @soil_productivity
        }

        $.post "backend/grower/fields/define/create-field", ko.toJSON(fieldPost), cb


